import { Injectable } from '@angular/core';
import { ComponentEffects, logCatchError } from '@mhe/reader/common';
import { ofType } from '@ngrx/effects';
import { map, withLatestFrom } from 'rxjs/operators';

import { ReaderStore } from '@mhe/reader/components/reader/state';
import * as readerActions from '@mhe/reader/components/reader/state/reader.actions';

@Injectable()
export class AiSummaryMediator extends ComponentEffects {
  private readonly readerActions$ = this.readerStore.actions$;

  constructor(
    private readonly readerStore: ReaderStore,
  ) {
    super();
  }

  /**
   * Toggle AI Summary panel open/closed state
   */
  private readonly toggleAiSummary$ = this.effect(() =>
    this.readerActions$.pipe(
      ofType(readerActions.toggleAiSummaryPanel),
      withLatestFrom(
        this.readerStore.isAiSummaryOpen$,
        this.readerStore.isAiAssistOpen$,
      ),
      map(([, summaryOpen, assistOpen]) => {
        const nextOpen = !summaryOpen;
        this.readerStore.setAiSummaryOpen(nextOpen);

        if (nextOpen && assistOpen) {
          this.readerStore.setAiAssistOpen(false);
        }
      }),
      logCatchError('toggleAiSummary$'),
    ),
  );
}
